export default __webpack_public_path__ + "static/media/stadium-bg-lg-ar.e6a8c68b.png";